// Define the base URL
const baseURL = `${window.location.origin}/api/v1`;

// System login routes
export const route_login_user = `${baseURL}/login`;         // Authentication route

export const route_tenant_config = `${baseURL}/tenants/config`

// Device related routes
export const route_devices = `${baseURL}/devices`;
export const route_get_device = `${baseURL}/devices/`;
export const route_add_device = `${baseURL}/devices/add/uuid`;
export const route_delete_device = `${baseURL}/devices/delete/uuid`;
export const route_update_device = `${baseURL}/devices/update/uuid`;
export const route_device_types = `${baseURL}/deviceConfig/types`;
export const route_readings = `${baseURL}/readings`;

// Firmware routes
export const route_get_firmwares = `${baseURL}/firmware`;
export const route_update_firmwares = `${baseURL}/firmware/update`;
export const route_upload_firmwares = `${baseURL}/firmware/upload`;
export const route_delete_firmwares = `${baseURL}/firmware/delete`;

// Data backup route
export const route_get_backups = `${baseURL}/backup`;
export const route_get_backup_download = `${baseURL}/backup/download`;
export const route_upload_backup = `${baseURL}/backup/upload`;

// MQTT service routes  
export const route_mqtt_led_flash = `${baseURL}/mqtt/led/2`; // Example MQTT route
export const route_mqtt_reboot = `${baseURL}/devices/reboot`;
export const route_mqtt_set_endpoint = `${baseURL}/devices/epSet`; // Example MQTT route for setting endpoint values

// misc constants, frontend request to backend interval
export const backend_request_interval_ms = 10000;
